export default __webpack_public_path__ + "static/Metropolis-Thin-1f59146bd13029f0a6c1441d7b57de26.woff2";